export default "__VITE_ASSET__46df0290__"